import { user } from './user.js'
import { userProfile } from './userProfile.js'
import { newPassword } from './newPassword.js'
import { webinar } from './webinar.js';
import { adminCreateUser } from './adminCreateUser.js';
import { sponsor } from './sponsor.js';

export {
  user,
  userProfile,
  newPassword,
  webinar,
  adminCreateUser,
  sponsor
}



/** WEBPACK FOOTER **
 ** ./src/validators/index.js
 **/